import { useEffect, useState } from 'react';
import _ from 'lodash';

import { GLOBAL_ADMIN_READ, GLOBAL_ADMIN_WRITE, useAuthStore } from '@/context/auth';

export function getAuthMenus(authStore, moduleMenus, moduleKey) {
    const childrenMenus = moduleMenus[moduleKey]?.children ?? [];
    return childrenMenus.filter(({ label, authorities }) => {
        if (!label) {
            return false;
        }

        if (_.isEmpty(authorities)) {
            return true;
        }
        return authStore.hasAuthorities(authorities, 'r');
    });
}

export function useMenuService(moduleMenus, moduleKey) {
    const [authStore] = useAuthStore();
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        const authMenus = getAuthMenus(authStore, moduleMenus, moduleKey);
        setMenus(authMenus);
    }, [authStore, moduleKey, moduleMenus]);

    return menus;
}

/**
 * 顶部导航栏权限
 */
export function useTopNavAuthService() {
    const [authStore] = useAuthStore();
    const { authorities } = authStore;
    const [adminEntry, setAdminEntry] = useState(false);
    const [conversationEntry, setConversationEntry] = useState(false);
    const [customerEntry, setCustomerEntry] = useState(false);
    const [shareEntry, setShareEntry] = useState(false);
    useEffect(() => {
        if (_.isEmpty(authorities)) {
            return;
        }

        const conversationAuth = authorities.find(
            auth =>
                auth.startsWith('global:conversation') ||
                auth === GLOBAL_ADMIN_READ ||
                auth === GLOBAL_ADMIN_WRITE
        );
        if (conversationAuth) {
            setConversationEntry(true);
        }
        const customerAuth = authorities.find(
            auth =>
                auth.startsWith('global:customer') ||
                auth === GLOBAL_ADMIN_READ ||
                auth === GLOBAL_ADMIN_WRITE
        );
        if (customerAuth) {
            setCustomerEntry(true);
        }

        const adminAuths = authorities.find(
            auth =>
                auth.startsWith('global:sys') ||
                auth === GLOBAL_ADMIN_READ ||
                auth === GLOBAL_ADMIN_WRITE
        );
        if (adminAuths) {
            setAdminEntry(true);
        }
        const shareAuths = authorities.find(
            auth =>
                auth.startsWith('global:share') ||
                auth === GLOBAL_ADMIN_READ ||
                auth === GLOBAL_ADMIN_WRITE
        );
        if (shareAuths) {
            setShareEntry(true);
        }
    }, [authorities]);

    return { adminEntry, conversationEntry, customerEntry, shareEntry };
}
